import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "App";
import theme from "theme";
import { Provider } from "react-redux";
import store from "app/store";
import { SnackbarProvider } from "notistack";
import { AOSInit } from "common/ASOInit";
// import SessionDilog from "components/session-dialog";

// Suppress benign Chrome extension / React DevTools bridge shutdown errors in dev
if (typeof window !== "undefined") {
  const isExtensionOrBridgeError = (error, message) => {
    const str = `${message || ""} ${error?.message || ""} ${error?.stack || ""}`;
    return (
      str.includes("Bridge that has been shut down") ||
      str.includes("chrome-extension://") ||
      str.includes("ResizeObserver loop")
    );
  };

  window.addEventListener(
    "error",
    (event) => {
      if (isExtensionOrBridgeError(event?.error, event?.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (isExtensionOrBridgeError(event?.reason, event?.reason?.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AOSInit />
      {/* <SessionDilog /> */}
      <Provider store={store}>
        <SnackbarProvider
          maxSnack={4}
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          preventDuplicate
        >
          <App />
        </SnackbarProvider>
      </Provider>
    </ThemeProvider>
  </StyledEngineProvider>,
);
